import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import WineLectures from './pages/WineLectures';
import WineTastings from './pages/WineTastings';
import About from './pages/About';
import Contact from './pages/Contact';

function App() {
  return (
    <div className="min-h-screen bg-stone-50 text-stone-900 font-sans selection:bg-rose-100 selection:text-rose-900 flex flex-col justify-between">
      <ScrollToTop />
      <Navbar />
      <div className="flex-grow">
        <Routes>
          {/* ================= Danish Routes (Primary / Default) ================= */}
          <Route path="/" element={<Home />} />
          <Route path="/vinsmagninger" element={<WineTastings />} />
          <Route path="/vinforedrag" element={<WineLectures />} />
          <Route path="/om-eliana" element={<About />} />
          <Route path="/kontakt" element={<Contact />} />

          {/* Danish redirects for /da prefixes to ensure canonical URLs */}
          <Route path="/da" element={<Navigate to="/" replace />} />
          <Route path="/da/vinsmagninger" element={<Navigate to="/vinsmagninger" replace />} />
          <Route path="/da/vinforedrag" element={<Navigate to="/vinforedrag" replace />} />
          <Route path="/da/om-eliana" element={<Navigate to="/om-eliana" replace />} />
          <Route path="/da/kontakt" element={<Navigate to="/kontakt" replace />} />

          {/* ================= English Routes (/en) ================= */}
          <Route path="/en" element={<Home />} />
          <Route path="/en/wine-tastings" element={<WineTastings />} />
          <Route path="/en/wine-lectures" element={<WineLectures />} />
          <Route path="/en/about-eliana" element={<About />} />
          <Route path="/en/contact" element={<Contact />} />

          {/* English aliases & legacy redirects */}
          <Route path="/en/vinsmagninger" element={<Navigate to="/en/wine-tastings" replace />} />
          <Route path="/en/vinforedrag" element={<Navigate to="/en/wine-lectures" replace />} />
          <Route path="/en/om-eliana" element={<Navigate to="/en/about-eliana" replace />} />
          <Route path="/en/kontakt" element={<Navigate to="/en/contact" replace />} />
          <Route path="/en/corporate-events" element={<Navigate to="/en/wine-tastings" replace />} />
          <Route path="/en/private-events" element={<Navigate to="/en/wine-tastings" replace />} />
          <Route path="/en/teambuilding" element={<Navigate to="/en/wine-tastings" replace />} />
          <Route path="/en/workshops" element={<Navigate to="/en/wine-tastings" replace />} />

          {/* Legacy Danish Service Redirects */}
          <Route path="/firmaevents" element={<Navigate to="/vinsmagninger" replace />} />
          <Route path="/private-events" element={<Navigate to="/vinsmagninger" replace />} />
          <Route path="/teambuilding" element={<Navigate to="/vinsmagninger" replace />} />
          <Route path="/workshops" element={<Navigate to="/vinsmagninger" replace />} />

          {/* 404 Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
      <Footer />
    </div>
  );
}

export default App;
